<template>
  <div class="serviceBhg">
    <div class="m-title">不合格现场服务单</div>
    <div class="board-box" v-loading="loading">
      <select-range :engData="filterList" @range-change="rangeChange" />
      <div :id="chartId" class="chart1"></div>
    </div>
  </div>
</template>

<script>
import common from './mixins/common'

/**
 * 柱形图
 */
export default {
  mixins: [common],
  name: 'ChartBarLine',
  props: {
    /**
     * 放置源头
     * - unqualified 管理-不合格现场服务单
     */
    source: {
      type: String,
      default: 'unqualified'
    }
  },
  data() {
    return {
      /** 是否需要更新下拉列表数据 */
      isUpdateFilter: true,
      filterList: [],
      chartData: {}
    }
  },
  computed: {
    conf: function() {
      const Map = {
        unqualified: {
          title: '不合格现场服务单',
          fieldConf: { xField: 'STATISTICAL_TIME', filterField: 'ENGINEER_NAME' }
          // fieldConf: { mock: true, xField: 'name', filterField: 'stage' }
        }
      }

      return Map[this.source] || {}
    }
  },
  watch: {
    chartData: function() {
      this.updateChart()
    }
  },
  mounted: function() {
    this.getData()
  },
  methods: {
    updateChart: function() {
      let chartData = this.chartData,
        conf = this.conf
      let options = {
        legend: {
          left: '12%',
          top: '7',
          data: ['当前数量']
        },
        series: [
          {
            name: '当前数量',
            type: 'bar',
            itemStyle: { color: '#5B8FF9' },
            barMaxWidth: '14',
            data: chartData.series || []
          },
          {
            name: '当前数量',
            type: 'line',
            lineStyle: { color: '#F6C021' },
            data: chartData.series || []
          }
        ],
        xAxis: [
          {
            type: 'category',
            triggerEvent: conf.triggerLabel,
            boundaryGap: true,
            data: chartData.xAxis || []
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: '（个）',
            boundaryGap: [0.2, 0.2],
            min: 0,
            minInterval: 1
          }
        ],
        dataZoom: {
          show: true,
          start: 0,
          end: (10 * 100) / chartData.xAxis.length,
          height: 15
        },
        grid: { right: 30, left: '8%', top: 40 },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#283b56'
            }
          },
          formatter: '不合格服务单<br/>{b0}: {c0}'
        }
      }

      this.chartIns && this.chartIns.setOption(options)
    },

    /**
     * 处理数据
     * @param {[]} list
     */
    processList: function(list) {
      let { xField, filterField } = this.conf.fieldConf

      let filterMap = {}
      let filterList = []

      let xAxis = [],
        series = [],
        total = 0

      let categoryMap = {}

      list.map(v => {
        let curX = v[xField],
          f = v[filterField]

        if (!filterMap[f]) {
          filterMap[f] = true
          filterList.push({ label: f, value: f })
        }

        if (!categoryMap[curX]) categoryMap[curX] = []
        categoryMap[curX].push(v)
      })

      xAxis = Object.keys(categoryMap)
      series = xAxis.map(curX => {
        let n = (categoryMap[curX] || []).reduce((total, cur) => (total += 1), 0)

        total += n
        return {
          name: [curX].join(','),
          value: n
        }
      })

      this.chartData = { xAxis, series, total }

      if (this.isUpdateFilter) {
        this.filterList = filterList
        this.isUpdateFilter = false
      }
    },

    /**
     * 获取数据
     * @param {import('./SelectRange.vue').IRange} range 选择日期、品牌、工程师
     */
    getData: function(range) {
      let condition = this.condition,
        { mock, filterField, timeField = 'YW_SERVICE_ORDER_CREATE_TIME' } = this.conf.fieldConf,
        source = this.source

      if (range) {
        if (range.type === 'date') {
          const tf = 'YYYY-MM-DD'
          // 日期变化
          let [start = '', end = ''] = range.data.current
          if (start === end) {
            // LIKE
            condition[`${timeField}:2`] = start + '%'
          } else {
            // <= 接口不包含此临界值，故需 +1 或者拼接时分秒
            end = moment(end)
              .add(1, 'day')
              .format(tf)

            condition[`${timeField}:5`] = start
            condition[`${timeField}:6`] = end
          }
          if (!start && !end) {
            delete condition[`${timeField}:2`]
            delete condition[`${timeField}:5`]
            delete condition[`${timeField}:6`]
          }
        } else if (range.type === 'engger') {
          let /** filter value */ fv = range.data.current,
            sourceList = this.sourceList

          let list = fv ? sourceList.filter(v => v[filterField] === fv) : sourceList
          this.isUpdateFilter = false

          this.processList(list)
          return
        }
      }

      this.loading = true
      let requestFn = ''
      if (source === 'unqualified') {
        requestFn = this.api.queryList(
          'YW_SERVICE_ORDER_UNQUALIFIED_V1',
          { p2: condition, p9: '' },
          'guanLi_chart_6_unqualified'
        )
      }
      requestFn.then(
        res => {
          this.loading = false
          let resData = (this.sourceList = res.result)

          // TODO: 模拟数据
          if (mock) {
            resData = this.sourceList = this.genTableData(100)
          }

          this.isUpdateFilter = true
          this.processList(resData)
        },
        err => {
          this.loading = false
        }
      )
    }
  }
}
</script>

<style lang="postcss">
/* 不合格现场服务单 */
.serviceBhg {
  display: flex;
  flex-direction: column;

  & .board-box {
    padding: 10px;
    flex: 1 200px;

    & .chart1 {
      height: 100%;
    }
  }
  & .select-range {
    /* position: static; */
    top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/viewBoard/components/ChartBarLine.vue